'use strict';
// write your code here
var texDataElement = document.querySelectorAll('span.population');
var texData = [];
var resultData = {
    total: 0,
    average: 0
};
texDataElement.forEach(function(item, index) {
    var valueItemNumber = +item.textContent.replaceAll(',', '');
    texData[index] = valueItemNumber;
    resultData.total += valueItemNumber;
});
resultData.average = resultData.total / texData.length | 0;
resultData.average = resultData.average.toLocaleString('en-US');
resultData.total = resultData.total.toLocaleString('en-US');
var elementTotal = document.querySelector('.total-population');
elementTotal.innerHTML = resultData.total;
var elementAve = document.querySelector('.average-population');
elementAve.innerHTML = resultData.average;

//# sourceMappingURL=js_get_data_DOM.b8309572.js.map
